import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const USER_TOKEN_KEY = "reveal_user_token";

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(USER_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const photoUrl = (path) => {
  const t = localStorage.getItem(USER_TOKEN_KEY);
  return `${API}/files/${path}${t ? `?auth=${t}` : ""}`;
};
